var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.barClass,on:{"mousedown":_vm.clickTrackHandler}},[_c('div',{ref:"thumb",staticClass:"sy-scrollbar-bar-thumb",style:(_vm.thumbStyle),on:{"mousedown":_vm.clickThumbHandler}})])}
var staticRenderFns = []

export { render, staticRenderFns }